import { combineReducers } from 'redux';
import { businessReducer } from './business/reducer';
import { categoriesReducer } from './categories/reducer';
import { collectionsReducer } from './collections/reducer';
import { notificationsReducer } from './notifications/reducer';
import { postsReducer } from './posts/reducer';
import { usersReducer } from './user/reducer';

export const rootReducer = combineReducers({
    posts: postsReducer,
    business: businessReducer,
    categories: categoriesReducer,
    notifications: notificationsReducer,
    users: usersReducer,
    collections: collectionsReducer,
});
